import * as angular from 'angular';
import { AtendimentoResource } from './atendimento.resource';
import { AtendimentoRouter } from './atendimento.router';
import { AtendimentoComentarioResource } from './comentarios.resource';
import { ContentEditableDirective } from './contenteditable.directive';
import { ResponderComponent } from './detalhes/responder/responder.component';
import { AtendimentoTabelaComponent } from './listagem/tabela/tabela.component';
import { AtendimentoFiltroComponent } from './listagem/filtro/filtro.component';
import { CodigoRastreamentoValidatorDirective } from './codigo-rastreamento.validator';
import { AtendimentoNovaSolicitacaoComponent } from './nova-solicitacao/nova-solicitacao.component';
import { AtendimentoDetalhesComponent } from './detalhes/detalhes.component';

export const AtendimentoModule = 'mandaeApp.atendimento';

angular.module(AtendimentoModule, [
  'ngFileUpload',
  'ngResource',
  'ngMaterial',
  'ngSanitize',
  'md.data.table',
])
.config(AtendimentoRouter)
.factory('AtendimentoResource', AtendimentoResource)
.factory('AtendimentoComentarioResource', AtendimentoComentarioResource)
.component((<any>AtendimentoTabelaComponent).componentName, <any>AtendimentoTabelaComponent)
.component('appResponderTicket', ResponderComponent)
.component((<any>AtendimentoDetalhesComponent).componentName, <any>AtendimentoDetalhesComponent)
.component((<any>AtendimentoFiltroComponent).componentName, <any>AtendimentoFiltroComponent)
.component('appAtendimentoNovaSolicitacao', {
  controller: AtendimentoNovaSolicitacaoComponent,
  controllerAs: '$ctrl',
  template: require('./nova-solicitacao/nova-solicitacao.component.html'),
})
.directive('contenteditable', ContentEditableDirective)
.directive('appCodigoRastreamentoValidator', CodigoRastreamentoValidatorDirective);
